import { getUser } from "helpers/localStorage";
import { canAccess } from "config/permissions";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const RequiredAuth = () => {
  const user = getUser();
  const location = useLocation();

  if (!user) {
    return (
      <Navigate
        to="/login"
        state={{
          from: location.pathname,
        }}
        replace
      />
    );
  }

  if (!canAccess(location.pathname, user.type)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default RequiredAuth;
